import { usePropertyWillBuildOnLandYourself } from '../../../../queries/PropertyFields/NonRentalLandFields';
import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { ApplicationQuestionReviewItem } from '../../../components/ApplicationQuestionReviewItem';

interface BuildOnLandYourselfProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const BuildOnLandYourself: React.FC<BuildOnLandYourselfProps> = ({ propertyGuid, required = false, isReview = false }) => {
    const label = 'Do you plan to build on all of the land yourself?';
    const [willBuildOnLandYourself, set_willBuildOnLandYourself] = usePropertyWillBuildOnLandYourself(propertyGuid);

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        switch (e.itemData?.id.toLowerCase()) {
            case 'yes':
                set_willBuildOnLandYourself(true);
                return;
            case 'no':
                set_willBuildOnLandYourself(false);
                return;
            default:
                return;
        }
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={willBuildOnLandYourself ? 'Yes' : 'No'}
                />
            ) : (
                <YesNoToggleButton
                    id='willBuildOnLandYourself'
                    value={willBuildOnLandYourself}
                    onItemClick={toggleButtonYesNoClick}
                    width='230px'
                    height='40px'
                    required={required}
                    requiredMessage='Will Build On Land Yourself required'
                    label={label}
                    labelSize={ToggleButtonLabelSize.Medium}
                />
            )}
        </>
    );
};
